<template>
  <input-select
    single
    v-model="conta"
    :options="contas"
    :search="pesquisaConta"
    :disabled="disabled"
    :required="required"
    @input="emiteInput"
  />
</template>
<script>
export default {
  data() {
    return {
      conta: null,
      contaAnterior: null,
      contas: [],
      firstLoadSelected: true
    };
  },
  props: {
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    codigoContaSelected: String,
    contaPgtoSelected: String
  },
  methods: {
    emiteInput(val) {
      if (val && this.contaAnterior != val) {
        this.$emit("input", val);
      }
      this.contaAnterior = val;
    },
    clearAll(){
      this.loadComboContas()
    },
    loadComboContas(conta) {
      if(conta === '') return
      if (this.firstLoadSelected && this.contaPgtoSelected) {conta = this.contaPgtoSelected}
      let dto = {
        parameters: [{ name: "numeroConta", value: conta }],
      };
      let th = this
      th.contas = [] 
      this.$api.Contas.ComboContas(dto).then(function (data) {
        if (Array.isArray(data)) {
          let arrayContas = [];
          data.forEach(function (item) {
            arrayContas.push({
              value: item.codigo,
              text: item.contaPgto,
            });
          });
          th.contas = arrayContas;
        }
        if (th.codigoContaSelected && th.firstLoadSelected) {
            th.conta = th.contas.find(e => e.value === th.codigoContaSelected).value
            th.firstLoadSelected = false
       }
      })
    },
  },
  watch:{
     codigoContaSelected: function (val) {
      if (val) {
        this.firstLoadSelected = true
        this.loadComboContas()
      }
    }
  },
  created() {
    this.pesquisaConta = _.debounce(this.loadComboContas, 300);
  },
};
</script>